import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% {
    height: 14px;
    opacity: 0.45;
  }
  50% {
    height: 42px;
    opacity: 1;
  }
`;

export const BarsContainer = styled.div`
  display: inline-flex;
  width: 64px;
  height: 48px;
  align-items: center;
  justify-content: center;
  gap: 4px;

  span {
    width: 6px;
    height: 14px;
    border-radius: 999px;
    background: #1675e0;
    animation: ${pulse} 1s ease-in-out infinite;
  }

  span:nth-child(2) {
    animation-delay: 0.1s;
  }

  span:nth-child(3) {
    animation-delay: 0.2s;
  }

  span:nth-child(4) {
    animation-delay: 0.3s;
  }

  span:nth-child(5) {
    animation-delay: 0.4s;
  }
`;
